import { lazy, Suspense, useEffect } from "react";
import { Route, Routes, useLocation } from "react-router";
import { getPageMetadata } from "@/config/routes";
import { syncDocumentMetadata } from "@/lib/seo";
import { PayaChat } from "@/features/support/PayaSupport";

const ContactPage = lazy(async () => ({
  default: (await import("@/pages/ContactPage")).ContactPage,
}));
const DashboardPage = lazy(async () => ({
  default: (await import("@/pages/DashboardPage")).DashboardPage,
}));
const HomePage = lazy(async () => ({
  default: (await import("@/pages/HomePage")).HomePage,
}));
const NotFoundPage = lazy(async () => ({
  default: (await import("@/pages/NotFoundPage")).NotFoundPage,
}));
const PrivacyPage = lazy(async () => ({
  default: (await import("@/pages/PrivacyPage")).PrivacyPage,
}));
const VehicleDebtsPage = lazy(async () => ({
  default: (await import("@/pages/VehicleDebtsPage")).VehicleDebtsPage,
}));
const PanelGuidePage = lazy(async () => ({
  default: (await import("@/pages/PanelGuidePage")).PanelGuidePage,
}));
const StyleGuidePage = lazy(async () => ({
  default: (await import("@/pages/StyleGuidePage")).StyleGuidePage,
}));

function DocumentMetadata() {
  const location = useLocation();

  useEffect(() => {
    syncDocumentMetadata(getPageMetadata(location.pathname));
  }, [location.pathname]);

  return null;
}

export function App() {
  return (
    <>
      <DocumentMetadata />
      <PayaChat />
      <Suspense
        fallback={
          <main id="main-content" className="route-loading" aria-busy="true">
            <span className="sr-only">در حال بارگذاری صفحه…</span>
          </main>
        }
      >
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/services/vehicle-debts" element={<VehicleDebtsPage />} />
          <Route path="/guides/vehicle-service-panel" element={<PanelGuidePage />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/style-guide" element={<StyleGuidePage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/404" element={<NotFoundPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Suspense>
    </>
  );
}
